
export const EMAIL_REGEX = "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$";

// TypeScript type declarations for xaLogLevel property
declare global {
    interface Window {
        xaLogLevel?: "debug";
        _xaLogLevel?: string;
    }
}

// Initialize log level from localStorage on module load
const STORAGE_KEY = 'xaLogLevel';
const storedLogLevel = localStorage.getItem(STORAGE_KEY);

// Define property with getter/setter to persist to localStorage
// Only define the property if it hasn't been defined yet
if (!Object.getOwnPropertyDescriptor(window, "xaLogLevel")) {
    Object.defineProperty(window, "xaLogLevel", {
        // Use a private property to avoid infinite recursion in the getter/setter
        get: function () {
            return this._xaLogLevel;
        },
        set: function (value) {
            this._xaLogLevel = value;
            if (value) {
                localStorage.setItem(STORAGE_KEY, value);
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
        },
        configurable: true,
        // enumerable: true makes property visible in Object.keys() and for...in loops
        // This is useful for debugging to see window.xaLogLevel in console inspection
        enumerable: true
    });
}

// Restore from localStorage if available
// Note: We don't check !window.xaLogLevel because the getter returns undefined initially,
// making such a check redundant on fresh loads
if (storedLogLevel) {
    window.xaLogLevel = storedLogLevel as "debug";
}

// Create a namespaced API on window.xapp for easier access
if (typeof window !== 'undefined') {
  (window as any).xapp = (window as any).xapp || {};
  (window as any).xapp.setLogLevel = (level: 'debug' | 'off') => {
    if (level === 'off') {
      (window as any).xaLogLevel = null;
      console.log('Log level set to: off (logs disabled)');
    } else {
      (window as any).xaLogLevel = level;
      console.log(`Log level set to: ${level}`);
    }
  };
  (window as any).xapp.getLogLevel = () => {
    return (window as any).xaLogLevel || 'off';
  };
}

// Returns current timestamp
function getCurrentDateString() {
  return (new Date()).toISOString() + " ::";
}

type LogParam = unknown;

export function log(...args: readonly LogParam[]): void {
  if (window.xaLogLevel === "debug") {
    console.log(getCurrentDateString(), ...args);
  }
}

export function err(...args: readonly LogParam[]): void {
  console.error(getCurrentDateString(), ...args);
}

export const logOnce = (key: string, ...args: readonly LogParam[]): void => {
  const map = {};
  if (!map[key]) {
    map[key] = true;
    log(...args);
  }
}

// export type Noop = () => void;
// tslint:disable-next-line:no-empty
// export const noop: Noop = () => {};

export { default as insertSorted } from "./insertSorted";
export * from "./nick-utils";
// export * from "./PersistentStorage";
export * from "./useIsMounted";
export * from "./retryRequest"
export * from "./time";
export * from "./formWidgetScript";